import { SelectItem } from '@/components/select/selectBoxTypes';

type MultiSelectionValue<T extends SelectItem> = T[] | string[];

const isStringArray = <T extends SelectItem>(value: MultiSelectionValue<T>): value is string[] =>
  value.every((item) => typeof item === 'string');

export const getInitialMultiSelection = <T extends SelectItem>(
  value: MultiSelectionValue<T>,
): T[] => (isStringArray(value) ? [] : value);

export const resolveMultiSelection = <T extends SelectItem>(
  items: T[],
  value: MultiSelectionValue<T>,
): T[] => {
  if (isStringArray(value)) {
    return items.filter((item) => value.includes(item.id));
  }

  return value;
};

export const normalizeMultiSelection = <T>(value: T | (T | null)[] | null): T[] =>
  Array.isArray(value) && value.every((item): item is T => item !== null) ? value : [];
